import AppPaths from '@globals/paths'
import { TenantMember } from '@kudos/http-client'
import { isAdminPath } from '@nav/utils'

const USER_FACING_PREVIEW_PREFIXES = [
  AppPaths.tenant.home(),
  AppPaths.tenant.memberProfile(''),
] as const

export const getMentionPreviewRegionId = (tenantMemberId: string) =>
  `mention-preview-${tenantMemberId}`

export const getMemberProfilePreviewRegionId = (tenantMemberId: string) =>
  `member-profile-preview-${tenantMemberId}`

export const isUserFacingPreviewRoute = (pathname: string): boolean =>
  USER_FACING_PREVIEW_PREFIXES.some(prefix => pathname === prefix || pathname.startsWith(prefix)) &&
  !isAdminPath(pathname)

export const isMemberProfilePreviewEnvironmentActive = (
  pathname: string,
  isDesktop: boolean,
  hasCurrentMember: boolean,
): boolean => Boolean(hasCurrentMember) && isDesktop && isUserFacingPreviewRoute(pathname)

export const isPreviewableTenantMember = (
  member: Pick<TenantMember, 'suspendedAt' | 'deletedAt'> | null | undefined,
): boolean => Boolean(member && !member.suspendedAt && !member.deletedAt)
